// Englische Texte Paket 5: Verkauf (VK-08, VK-10, VK-11, VK-15 bis VK-18), Schiffe (SCH-04, SCH-06, SCH-09), Zusammenführen (ST-06, MI-04)
export default {
  'Kopfdaten gespeichert. Positionen der Bestellung mit „Kundenbestellung erfassen“ abgleichen.': 'Header saved. Compare the purchase order items with Record purchase order.',
  'Abgleich der Kundenbestellung': 'Purchase order check',
  'Abgleich: Die Bestellung stimmt mit den Positionen überein.': 'Check complete: the purchase order matches the items.',
  'Abgleich: {n} Abweichung zum Prüfen.': 'Check complete: {n} difference to review.',
  'Abgleich: {n} Abweichungen zum Prüfen.': 'Check complete: {n} differences to review.',
  'Abgleichen': 'Compare',
  'Abweichungen zeigen': 'Show differences',
  'Agent': 'Agent',
  'Agent übernehmen': 'Use agent',
  'Agent: {agent}': 'Agent: {agent}',
  'Aktivieren': 'Activate',
  'Alle ({n})': 'All ({n})',
  'Alle Lieferantenbestellungen auslösen': 'Place all supplier orders',
  'Alle Lieferantenbestellungen erfassen (Senden danach in der Beschaffung)': 'Record all supplier orders (send them afterwards under Procurement)',
  'Alle Positionen sind bereits bestellt.': 'All items have already been ordered.',
  'Alle Positionen sind bereits geliefert.': 'All items have already been delivered.',
  'Alle Reklamationen mit Status, Position und Lieferant': 'All complaints with status, item and supplier',
  'Alle Schiffe': 'All vessels',
  'Alle Schiffe haben eine IMO': 'All vessels have an IMO number',
  'Alle aktiven': 'All active',
  'Alle bestätigen': 'Confirm all',
  'Alle, auch pausierte und verworfene': 'All, including paused and discarded',
  'Anderen Lieferanten suchen': 'Search other supplier',
  'Anderes Schiff suchen': 'Search other vessel',
  'Angebote nutzen die Vorlage des Kunden': 'Quotations use the customer\'s template',
  'Angebotsvorlage': 'Quotation template',
  'Angebotsvorlage gelöscht.': 'Quotation template deleted.',
  'Angebotsvorlage gespeichert.': 'Quotation template saved.',
  'Angebotsvorlage löschen?': 'Delete quotation template?',
  'Anlage des Schiffs': 'Vessel machinery',
  'Anlieferhinweise des Schiffs': 'Vessel delivery instructions',
  'Anlieferhinweise des Schiffs auf den Lieferschein': 'Print vessel delivery instructions on the delivery note',
  'Artikelsuche nur passend zu {anlage}': 'Item search only matching {anlage}',
  'Aufschlag laut Angebotsvorlage: {wert} %': 'Mark-up from quotation template: {wert} %',
  'Auftrag freigegeben, Schritt {schritt}': 'Order released, step {schritt}',
  'Auftragsbestätigung als Entwurf erzeugen': 'Create order confirmation as draft',
  'Auftragsbestätigung als Entwurf erzeugt': 'Order confirmation created as draft',
  'Auftragsbestätigung lag schon vor': 'Order confirmation already existed',
  'Auftragsbestätigung öffnen': 'Open order confirmation',
  'Aus Historie erkennen': 'Detect from history',
  'Ausblenden': 'Hide',
  'Bedarf': 'Requirement',
  'Bedarf angelegt.': 'Requirement created.',
  'Bedarf anlegen': 'Create requirement',
  'Bedarf bearbeiten': 'Edit requirement',
  'Bedarf gespeichert.': 'Requirement saved.',
  'Bedarf verwerfen?': 'Discard requirement?',
  'Berechnet': 'Invoiced',
  'Besonderheiten': 'Special instructions',
  'Bestellt am': 'Ordered on',
  'Bestellt {b}, Rest {r} {einheit}': 'Ordered {b}, remaining {r} {einheit}',
  'Bestellung aus der Mail einfügen': 'Paste the purchase order from the email',
  'Bestellung dem Vorgang {nummer} zugeordnet, keine Abweichung zum Angebot.': 'Purchase order assigned to {nummer}, no difference to the quotation.',
  'Bestellung dem Vorgang {nummer} zugeordnet: {n} Abweichung zum Prüfen.': 'Purchase order assigned to {nummer}: {n} difference to review.',
  'Bestellung dem Vorgang {nummer} zugeordnet: {n} Abweichungen zum Prüfen.': 'Purchase order assigned to {nummer}: {n} differences to review.',
  'Bestellung des Kunden mit dem Angebot abgleichen': 'Compare the customer\'s purchase order with the quotation',
  'Bestellung wird abgeglichen …': 'Comparing purchase order …',
  'Bestellung zu einem Angebot': 'Purchase order for a quotation',
  'Bestellung: {text}': 'Purchase order: {text}',
  'Bestellungen an Lieferanten senden': 'Send orders to suppliers',
  'Bitte den nächsten Termin angeben.': 'Please enter the next date.',
  'Bitte kurz beschreiben, was reklamiert wird.': 'Please describe briefly what the complaint is about.',
  'Bitte mindestens eine Menge größer als 0 eintragen.': 'Please enter at least one quantity greater than 0.',
  'Das Intervall muss zwischen 7 und 3650 Tagen liegen.': 'The interval must be between 7 and 3650 days.',
  'Defekt': 'Defective',
  'Der Aufschlag muss zwischen -50 und 1000 % liegen.': 'The mark-up must be between -50 and 1000 %.',
  'Der Vorlauf muss zwischen 0 und 365 Tagen liegen.': 'The lead time must be between 0 and 365 days.',
  'Die Auftragsbestätigung liegt als Entwurf vor. Prüfen, ausstellen und an den Kunden senden.': 'The order confirmation is ready as a draft. Check it, issue it and send it to the customer.',
  'Die Bestellung hat keine Zeilen.': 'The purchase order has no lines.',
  'Die Gültigkeit muss zwischen 1 und 365 Tagen liegen.': 'The validity must be between 1 and 365 days.',
  'Die IMO hat 7 Ziffern.': 'The IMO number has 7 digits.',
  'Diese IMO hat bereits ein anderes Schiff. Bitte zusammenführen.': 'Another vessel already has this IMO number. Please merge them.',
  'Dieser Lieferant wurde zusammengeführt.': 'This supplier has been merged.',
  'Dieses Schiff wurde zusammengeführt.': 'This vessel has been merged.',
  'Dublette': 'Duplicate',
  'Erkennung abgeschlossen: {neu} neu, {akt} aktualisiert.': 'Detection complete: {neu} new, {akt} updated.',
  'Ersatz': 'Replacement',
  'Falsches Teil geliefert': 'Wrong part delivered',
  'Fehlmenge': 'Short delivery',
  'Filtert die Artikelvorschläge nach Hersteller und Typ der Anlage': 'Filters item suggestions by maker and type of the machinery',
  'Firma, Nummer, Ort': 'Company, number, town',
  'Firma, Ort, Telefon': 'Company, town, phone',
  'Fuß des Angebots': 'Quotation footer',
  'Fällig ({n})': 'Due ({n})',
  'Fällige Bedarfe auswählen und mit einem Klick als Vorgang anlegen. Merkan fasst sie je Kunde und Schiff zusammen und nennt im Verlauf die Grundlage.': 'Select due requirements and create a case with one click. Merkan groups them by customer and vessel and records the basis in the history.',
  'Für den Kunden im Kundenportal sichtbar machen': 'Make visible to the customer in the customer portal',
  'Für diesen Kunden, dieses Schiff und dieses Teil gibt es schon einen Bedarf.': 'A requirement for this customer, vessel and part already exists.',
  'Ganzer Vorgang': 'Whole case',
  'Gemeldet': 'Reported',
  'Gestrichen, aber bestellt': 'Cancelled, but ordered',
  'Gleicht ab …': 'Comparing …',
  'Grund': 'Reason',
  'Gutschrift aus Reklamation': 'Credit note from complaint',
  'Gutschrift öffnen': 'Open credit note',
  'Gültigkeit': 'Validity',
  'Gültigkeit in Tagen': 'Validity in days',
  'Häfen': 'Ports',
  'Häfen: {liste}': 'Ports: {liste}',
  'IMO für {name}': 'IMO number for {name}',
  'IMO {imo} für {name} gespeichert.': 'IMO {imo} saved for {name}.',
  'Im Kundenportal sichtbar': 'Visible in the customer portal',
  'Intervall': 'Interval',
  'Intervall in Tagen': 'Interval in days',
  'Jede bestellte Zeile braucht eine Menge größer als 0.': 'Every ordered line needs a quantity greater than 0.',
  'Keine Anlage gewählt': 'No machinery selected',
  'Keine Rechnung': 'No invoice',
  'Keine Reklamationen': 'No complaints',
  'Keine Vorlage. Angebote nutzen die Standardtexte des Mandanten.': 'No template. Quotations use the company\'s standard texts.',
  'Keine möglichen Dubletten': 'No possible duplicates',
  'Keine naheliegende Dublette gefunden. Bitte suchen.': 'No obvious duplicate found. Please search.',
  'Keine neuen wiederkehrenden Bedarfe in der Historie gefunden.': 'No new recurring requirements found in the history.',
  'Keine offenen Reklamationen': 'No open complaints',
  'Keine wiederkehrenden Bedarfe': 'No recurring requirements',
  'Keiner': 'None',
  'Kontakte, Nachrichten, Bestellungen, Eingangsrechnungen, Wareneingänge, Kalkulation, Lieferantenangebote, Artikel-Lieferanten, Bezugsquellen und gelernte Zuordnungen gehen auf den Ziellieferanten über. Leere Felder dort werden ergänzt. Die Dublette wird inaktiv.': 'Contacts, messages, orders, supplier invoices, goods receipts, costing, supplier quotations, item suppliers, sources and learned assignments move to the target supplier. Empty fields there are filled in. The duplicate becomes inactive.',
  'Kunde wählen …': 'Select customer …',
  'Kundenbestellung erfassen': 'Record purchase order',
  'Kundenbestellung {nummer} abgeglichen': 'Purchase order {nummer} checked',
  'Kundenbestellung {nummer}: {n} offene Abweichungen': 'Purchase order {nummer}: {n} open differences',
  'Leer lassen: Merkan nimmt den Lieferanten aus Kalkulation oder Bestellung': 'Leave empty: Merkan takes the supplier from costing or order',
  'Leer: Standardtext': 'Empty: standard text',
  'Lieferantenbestellungen erst nach Zahlungseingang (Vorkasse)': 'Supplier orders only after payment (payment in advance)',
  'Lieferbedingungen': 'Terms of delivery',
  'Lieferschein über Restmengen': 'Delivery note for remaining quantities',
  'Liegeplätze, Vorankündigung, Zeitfenster': 'Berths, advance notice, time slots',
  'Lösung oder Notiz zum Status': 'Resolution or note on the status',
  'Mehr als die Restmenge bei Position {liste}.': 'More than the remaining quantity for item {liste}.',
  'Mehrere mit Komma trennen': 'Separate several with commas',
  'Menge 0 lässt die Position weg. Bereits erzeugte Belege, auch Entwürfe, sind abgezogen.': 'Quantity 0 leaves the item out. Documents already created, including drafts, are deducted.',
  'Menge Position {n}': 'Quantity item {n}',
  'Menge abweichend': 'Quantity differs',
  'Menge {ist}': 'Quantity {ist}',
  'Menge {n}': 'Quantity {n}',
  'Mengen': 'Quantities',
  'Mengen je Position': 'Quantities per item',
  'Merkan erkennt sie unter Verkauf, Wiederkehrende Bedarfe aus früheren Vorgängen.': 'Merkan detects them from earlier cases under Sales, Recurring requirements.',
  'Merkan gleicht die Bestellung mit den Positionen des Vorgangs ab und markiert Abweichungen.': 'Merkan compares the purchase order with the items of the case and marks differences.',
  'Mit „Aus Historie erkennen“ sucht Merkan in früheren Vorgängen nach Teilen, die mindestens dreimal in regelmäßigen Abständen angefragt wurden.': 'With Detect from history, Merkan searches earlier cases for parts requested at least three times at regular intervals.',
  'Mögliche Dublette': 'Possible duplicate',
  'Mögliche Dublette:': 'Possible duplicate:',
  'Mögliche Dubletten:': 'Possible duplicates:',
  'Nach Status filtern': 'Filter by status',
  'Nach Zahlungseingang bestellt: {liste}': 'Ordered after receipt of payment: {liste}',
  'Nacharbeit': 'Follow-up',
  'Name enthalten': 'name contained',
  'Name, frühere Namen, IMO': 'Name, former names, IMO',
  'Neue Angebote nutzen dann wieder die Standardtexte.': 'New quotations will then use the standard texts again.',
  'Neue Reklamation': 'New complaint',
  'Neuen Vorgang anlegen': 'Create new case',
  'Nicht bestellt': 'Not ordered',
  'Nicht gewählt': 'Not selected',
  'Nummer, Vorgang, Kunde, Teil': 'Number, case, customer, part',
  'Nächster Bedarf': 'Next requirement',
  'Offen ({n})': 'Open ({n})',
  'Ohne Auswahl entsteht ein neuer Vorgang.': 'Without a selection, a new case is created.',
  'Ohne Schiff': 'Without vessel',
  'Ort zum Incoterm': 'Incoterm place',
  'Passende Artikel zu {anlage}': 'Matching items for {anlage}',
  'Pausieren': 'Pause',
  'Position {n}: bitte eine Menge von 0 oder mehr eingeben.': 'Item {n}: please enter a quantity of 0 or more.',
  'Preis': 'Price',
  'Preis abweichend': 'Price differs',
  'Preis pro Stück (€)': 'Unit price (€)',
  'Prüfen und zusammenführen': 'Check and merge',
  'Qualitätsmangel': 'Quality defect',
  'Rechnungsposition': 'Invoice line',
  'Referenz des Lieferanten': 'Supplier reference',
  'Reklamation angelegt.': 'Complaint created.',
  'Reklamation anlegen': 'Create complaint',
  'Reklamation gespeichert.': 'Complaint saved.',
  'Reklamation zu Position {n}': 'Complaint for item {n}',
  'Reklamation {nummer}': 'Complaint {nummer}',
  'Reklamationen': 'Complaints',
  'Reklamationen werden in der Vorgangsakte an einer Position oder Rechnung angelegt.': 'Complaints are created in the case file for an item or invoice.',
  'Reklamationen zu einer Position oder Rechnung erscheinen hier mit Status und Verlauf.': 'Complaints about an item or invoice appear here with status and history.',
  'Rest': 'Remaining',
  'Schiff im Text:': 'Vessel in text:',
  'Schiffe ohne IMO': 'Vessels without IMO number',
  'So lange vorher erscheint der Vorschlag': 'The suggestion appears this many days in advance',
  'Sprache der Angebote': 'Quotation language',
  'Summe der Bestellung': 'Purchase order total',
  'Teil, Kunde, Schiff': 'Part, customer, vessel',
  'Teil-AB': 'Partial order confirmation',
  'Teilauftragsbestätigung als Entwurf erzeugt.': 'Partial order confirmation created as draft.',
  'Teilbelege mit offenen Restmengen': 'Partial documents with open remaining quantities',
  'Teile, die Kunden in regelmäßigen Abständen brauchen, mit Vorschlag für den nächsten Vorgang': 'Parts that customers need at regular intervals, with a suggestion for the next case',
  'Teillieferschein erzeugt. Die Restmengen bleiben offen.': 'Partial delivery note created. The remaining quantities stay open.',
  'Teilmenge erzeugen': 'Create partial quantity',
  'Teilmenge …': 'Partial quantity …',
  'Teilmengen: {art}': 'Partial quantities: {art}',
  'Teilrechnung': 'Partial invoice',
  'Teilrechnung als Entwurf erzeugt.': 'Partial invoice created as draft.',
  'Text der Bestellung': 'Purchase order text',
  'Texte': 'Texts',
  'Transportschaden': 'Transport damage',
  'Vom Kunden gestrichen': 'Cancelled by customer',
  'Vorbelegt mit den Positionen des Vorgangs. Nur ändern, was die Bestellung anders nennt: Menge, Preis, nicht bestellte Zeilen abwählen, zusätzliche Zeilen ergänzen.': 'Prefilled with the items of the case. Change only what the purchase order states differently: quantity, price, untick lines not ordered, add extra lines.',
  'Vorgang {nummern} angelegt.': 'Case {nummern} created.',
  'Vorgang {soll}, Bestellung {ist}': 'Case {soll}, purchase order {ist}',
  'Vorgeschlagen sind die Restmengen': 'The remaining quantities are suggested',
  'Vorgänge, Anlagen, Historie und wiederkehrende Bedarfe gehen auf das Zielschiff über. Leere Felder dort werden ergänzt, die IMO wandert mit. Ein abweichender Name wird als früherer Name gespeichert, damit Mails damit weiter erkannt werden.': 'Cases, machinery, history and recurring requirements move to the target vessel. Empty fields there are filled in and the IMO number moves along. A different name is stored as a former name so that emails using it are still recognised.',
  'Vorlauf in Tagen': 'Lead time in days',
  'Vorschlag in der Kalkulation': 'Suggested in costing',
  'Was meldet der Kunde?': 'What does the customer report?',
  'Weitere Teil-AB (Restmengen)': 'Further partial order confirmation (remaining quantities)',
  'Weitere Teilrechnung (Restmengen)': 'Further partial invoice (remaining quantities)',
  'Welcher Datensatz bleibt?': 'Which record is kept?',
  'Wie beim Kunden': 'As for the customer',
  'Wiederkehrende Bedarfe': 'Recurring requirements',
  'Wiederkehrender Bedarf': 'Recurring requirement',
  'Wird beim Erstellen eines Angebots übernommen': 'Applied when a quotation is created',
  'Wird bestellt …': 'Ordering …',
  'Wird freigegeben …': 'Releasing …',
  'Zahlung eingegangen.': 'Payment received.',
  'Zahlungsbedingungen': 'Terms of payment',
  'Zeile ergänzen': 'Add line',
  'Zeile {n} bestellt': 'Line {n} ordered',
  'Zeilen aus Text erkennen': 'Detect lines from text',
  'Zeilen aus dem Text übernommen. Preise nur eintragen, wenn die Bestellung welche nennt.': 'Lines taken from the text. Enter prices only if the purchase order states them.',
  'Zeilen erkennen': 'Detect lines',
  'Zu {vorgang} zuordnen, Angebot {angebot} vom {datum}': 'Assign to {vorgang}, quotation {angebot} dated {datum}',
  'Zuerst die Rechnung wählen': 'Select the invoice first',
  'Zum Vorgang': 'To the case',
  'Zum Vorgang gibt es noch keine ausgestellte Rechnung': 'No invoice has been issued for this case yet',
  'Zum Ziellieferanten': 'To the target supplier',
  'Zum Zielschiff': 'To the target vessel',
  'Zuordnen und abgleichen': 'Assign and compare',
  'Zurzeit ist kein Bedarf fällig': 'No requirement is currently due',
  'Zusammengeführt: {k} Kontakte, {b} Bestellungen, {e} Eingangsrechnungen, {a} Artikel.': 'Merged: {k} contacts, {b} orders, {e} supplier invoices, {a} items.',
  'Zusammengeführt: {v} Vorgänge, {a} Anlagen, {h} Historieneinträge.': 'Merged: {v} cases, {a} machinery entries, {h} history entries.',
  'Zusätzlich bestellt': 'Additionally ordered',
  'alle {n} Tage': 'every {n} days',
  'beim Lieferanten': 'with supplier',
  'davon {n} Entwurf': 'of which {n} draft',
  'erkannt': 'detected',
  'ganzer Vorgang': 'whole case',
  'gemeldet': 'reported',
  'gleiche IBAN': 'same IBAN',
  'gleiche IMO': 'same IMO number',
  'gleiche IMO, gleicher oder enthaltener Name': 'same IMO number, same or contained name',
  'heute {name}': 'now {name}',
  'in Prüfung': 'under review',
  'letzter Vorgang': 'last case',
  'manuell angelegt': 'created manually',
  'ohne IMO': 'without IMO number',
  'pausiert': 'paused',
  'seit {n} Tag fällig': 'due for {n} day',
  'seit {n} Tagen fällig': 'due for {n} days',
  'verworfen': 'discarded',
  'vom {datum}': 'dated {datum}',
  'z. B. Hamburg': 'e.g. Hamburg',
  'z. B. RMA-Nummer': 'e.g. RMA number',
  'zuletzt {datum}': 'last {datum}',
  '{art} über {n} Position erzeugen': 'Create {art} for {n} item',
  '{art} über {n} Positionen erzeugen': 'Create {art} for {n} items',
  '{name} zusammenführen': 'Merge {name}',
  '{n} Abweichung bestätigt.': '{n} difference confirmed.',
  '{n} Abweichung übernommen.': '{n} difference applied.',
  '{n} Abweichungen bestätigt.': '{n} differences confirmed.',
  '{n} Abweichungen übernommen.': '{n} differences applied.',
  '{n} Bedarf gewählt': '{n} requirement selected',
  '{n} Bedarfe gewählt': '{n} requirements selected',
  '{n} Lieferantenbestellung erfasst': '{n} supplier order recorded',
  '{n} Lieferantenbestellung erfasst. Bitte in der Beschaffung senden.': '{n} supplier order recorded. Please send it under Procurement.',
  '{n} Lieferantenbestellungen erfasst': '{n} supplier orders recorded',
  '{n} Lieferantenbestellungen erfasst. Bitte in der Beschaffung senden.': '{n} supplier orders recorded. Please send them under Procurement.',
  '{n} Position ist noch nicht bestellt.': '{n} item has not been ordered yet.',
  '{n} Position ohne Lieferant': '{n} item without supplier',
  '{n} Position ohne Lieferant. Bitte in der Beschaffung zuordnen.': '{n} item without supplier. Please assign one under Procurement.',
  '{n} Positionen ohne Lieferant': '{n} items without supplier',
  '{n} Positionen ohne Lieferant. Bitte in der Beschaffung zuordnen.': '{n} items without supplier. Please assign them under Procurement.',
  '{n} Positionen sind noch nicht bestellt.': '{n} items have not been ordered yet.',
  '{n} Reklamation': '{n} complaint',
  '{n} Reklamationen': '{n} complaints',
  '{n} Vorgänge angelegt: {nummern}.': '{n} cases created: {nummern}.',
  '{n} von {von} berechnet': '{n} of {von} invoiced',
  '{n} von {von} bestätigt': '{n} of {von} confirmed',
  '{n} von {von} geliefert': '{n} of {von} delivered',
  '{n} zu berechnen': '{n} to invoice',
  '{n} zu liefern': '{n} to deliver',
  '{quelle} wird in {ziel} überführt. Das lässt sich nicht automatisch rückgängig machen.': '{quelle} will be merged into {ziel}. This cannot be undone automatically.',
  '{teil} wird nicht mehr vorgeschlagen und bei der Erkennung übergangen.': '{teil} will no longer be suggested and will be skipped by the detection.',
  '{teil} wählen': 'Select {teil}',
  '{u} übernommen, {b} bestätigt': '{u} applied, {b} confirmed',
  'Übernehmen passt den Vorgang an die Bestellung an. Bestätigen lässt den Vorgang unverändert, zum Beispiel wenn die Auftragsbestätigung die Abweichung klärt.': 'Apply adjusts the case to the purchase order. Confirm leaves the case unchanged, for example when the order confirmation clarifies the difference.',
  'Üblicher Agent': 'Usual agent',
} satisfies Record<string, string>;
